import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { WEB_TYPE } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { LINK_URL } from "infrastructure/config/CONSTANTS"

interface props {
    masterUseCase: MasterUseCaseInterface;
}

const CU01101Page = ({ masterUseCase }: props) => {
    const [webUrl, setWebUrl] = useState<string>('');

    useEffect(() => {
        getWebAppUrl(WEB_TYPE.CU_011_01);
    }, []);

    const getWebAppUrl = async (type: number) => {
        try {
            setWebUrl(LINK_URL.FAQ);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            console.log();
        }
    };

    return (
        <div className="CU-011-01-container">
            <section>
                <PageTitle title="よくある質問" />
            </section>
            <section className="body">
                {webUrl ? (
                    <iframe src={webUrl} className="page content"></iframe>
                ) : (
                    <div className="page non-content">
                        <span>Webコンテンツが表示されます。</span>
                    </div>
                )}
            </section>
        </div>
    );
};

export default CU01101Page;
